/**
 * 滚动下拉消失
 */
import $ from 'jquery';

export default {
	
	mounted: function() {
		
		$(window).scroll(function () {
			if ($(this).scrollTop() > 142) {
				$('.el-select-dropdown').css('display', 'none');
				$('.el-input--suffix').removeClass('is-focus');
				$('.el-icon-arrow-up').removeClass('is-reverse');
			} else {
				
			}
		});
		
	}

}
